var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9064 26.0914C15.0287 26.269 15.1923 26.4143 15.3833 26.5146C15.5742 26.615 15.7867 26.6674 16.0024 26.6674C16.218 26.6674 16.4305 26.615 16.6214 26.5146C16.8124 26.4143 16.976 26.269 17.0984 26.0914L29.0984 8.75802C29.2373 8.5581 29.3187 8.32393 29.3339 8.08096C29.349 7.83799 29.2973 7.59552 29.1843 7.37988C29.0714 7.16424 28.9015 6.98368 28.6931 6.85783C28.4847 6.73198 28.2458 6.66564 28.0024 6.66602L4.00236 6.66602C3.75948 6.66702 3.52147 6.73421 3.31393 6.86037C3.10639 6.98652 2.93716 7.16687 2.82445 7.38201C2.71174 7.59715 2.6598 7.83894 2.67424 8.08139C2.68867 8.32384 2.76892 8.55777 2.90636 8.75802L14.9064 26.0914Z",
    fill: "#161616"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.4513d491cd686735960c20a7ddaaed4d.svg";
export { ForwardRef as ReactComponent };